import { provideTranslocoScope } from '@jsverse/transloco';
import { Component, ViewEncapsulation } from '@angular/core';
import { LoadingSpinner } from 'design-system';

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-cart-loading-overlay',
  imports: [LoadingSpinner],
  templateUrl: './cart-loading-overlay.html',
  styleUrl: './cart-loading-overlay.scss',
  // Necessario per stilizzare il pannello e il backdrop dell'overlay
  // (.cart-loading-panel, .cart-loading-backdrop), che stanno fuori dal DOM del componente
  encapsulation: ViewEncapsulation.None,
})
export class CartLoadingOverlay {
}
